import * as React from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { US_STATES } from "../constants/usStates";

/**
 * State dropdown (US states + DC). No default value.
 * @param {string} value - Two-letter state code (e.g. "MN")
 * @param {(value: string) => void} onChange - Called with state code when selection changes
 * @param {object} [sx] - MUI sx prop
 * @param {boolean} [required] - Mark as required
 * @param {string} [label='State']
 * @param {string} [size] - 'small' | 'medium'
 */
export default function StateSelect({
  value,
  onChange,
  sx,
  required = false,
  label = "State",
  size = "medium",
}) {
  return (
    <FormControl sx={{ minWidth: 120, ...sx }} size={size} required={required}>
      <InputLabel id="state-select-label" shrink>
        {label}
      </InputLabel>
      <Select
        labelId="state-select-label"
        label={label}
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        displayEmpty
      >
        <MenuItem value=""> </MenuItem>
        {US_STATES.map((s) => (
          <MenuItem key={s.value} value={s.value}>
            {s.label} ({s.value})
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
